import React from 'react';

//mui
import { Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';

// utils
import { getStorageLinks } from '../utils/util';

// interface

//configuration
import { roles } from '../configurations/settings';
var AccordionComponent = function AccordionComponent(props) {
  var _props$sections, _props$sections2, _props$sections3, _props$sections4, _props$sections5, _props$sections6;
  return /*#__PURE__*/React.createElement(Accordion, {
    defaultExpanded: true,
    sx: {
      border: 'none !important',
      boxShadow: 'none !important',
      background: 'white !important',
      position: 'inherit !important'
    }
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    sx: {
      display: 'flex !important',
      padding: '0 !important'
    },
    expandIcon: /*#__PURE__*/React.createElement(Box, {
      sx: {
        width: '25px'
      },
      component: "img",
      src: getStorageLinks(props.environment).cdn + '/assets/img/dropdown-downarrow.svg'
    }),
    "aria-controls": "panel2a-content",
    id: "panel2a-header"
  }, (props === null || props === void 0 || (_props$sections = props.sections) === null || _props$sections === void 0 ? void 0 : _props$sections.sectionName) === 'REGISTRATION.SHIPPING_ADDRESS' && (props === null || props === void 0 ? void 0 : props.role) === roles.SELLER_ROLE ? '' : props === null || props === void 0 ? void 0 : props.headerCallback(props === null || props === void 0 || (_props$sections2 = props.sections) === null || _props$sections2 === void 0 ? void 0 : _props$sections2.sectionName, props === null || props === void 0 || (_props$sections3 = props.sections) === null || _props$sections3 === void 0 ? void 0 : _props$sections3.description)), /*#__PURE__*/React.createElement(AccordionDetails, {
    sx: {
      padding: '0 !important'
    }
  }, (props === null || props === void 0 ? void 0 : props.type) === 'fieldType' && (props === null || props === void 0 ? void 0 : props.contentCallback(props === null || props === void 0 || (_props$sections4 = props.sections) === null || _props$sections4 === void 0 ? void 0 : _props$sections4.fields)), (props === null || props === void 0 ? void 0 : props.type) === 'documentType' && (props === null || props === void 0 || (_props$sections5 = props.sections) === null || _props$sections5 === void 0 ? void 0 : _props$sections5.documents) && (props === null || props === void 0 ? void 0 : props.contentCallback(props === null || props === void 0 || (_props$sections6 = props.sections) === null || _props$sections6 === void 0 ? void 0 : _props$sections6.documents))));
};
export default AccordionComponent;